import { useQuery } from 'react-query';
import { queryAllReceipts } from './useAllReceipts.query';
import { UseAllReceiptsOptions } from './useAllReceipts.types';
import { ReceiptENT } from '../../../types/models/receipt/receipt.types';

export const ALL_RECEIPTS_QUERY_KEY = 'ALL_RECEIPTS';

export const useAllReceipts = (options?: UseAllReceiptsOptions) => {
  return useQuery<ReceiptENT[], Error>(ALL_RECEIPTS_QUERY_KEY, () => queryAllReceipts(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
